export const LOGISTICS_SETTINGS_RESET_STATE = 'LOGISTICS_SETTINGS_RESET_STATE';
export const LOGISTICS_SETTINGS_CURRENT_ITEM = 'LOGISTICS_SETTINGS_CURRENT_ITEM';

export const LOGISTICS_SETTINGS_REQUEST_LOADING = 'LOGISTICS_SETTINGS_REQUEST_LOADING';
export const LOGISTICS_SETTINGS_REQUEST_SUCCESS = 'LOGISTICS_SETTINGS_REQUEST_SUCCESS';
export const LOGISTICS_SETTINGS_REQUEST_FAILED = 'LOGISTICS_SETTINGS_REQUEST_FAILED';

export const LOGISTICS_SETTINGS_CURRENT_ACTION = 'LOGISTICS_SETTINGS_CURRENT_ACTION';
export const LOGISTICS_SETTINGS_RESET_ACTION = 'LOGISTICS_SETTINGS_RESET_ACTION';
